import { z } from "zod";

export const partnerSettingsSchema = z.object({
  enabled: z.boolean(),
  destinationId: z.string().optional(),
  destinationName: z.string().optional(),
  destinationType: z.string().optional(),
  autoSyncEnabled: z.boolean(),
});

export type PartnerSettingsFormValues = z.infer<typeof partnerSettingsSchema>;
